import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next';

import './ContentSection.scss'

type Props= {
  comingSoon: boolean,
  title: string,
  description: string,
  numberOfChapters: number,
  numberOfTests: number,
  numberOfCertifications: number
}

export const ContentSection = ({ comingSoon, title, description, numberOfChapters, numberOfTests, numberOfCertifications, children }: PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  const chapters = numberOfChapters > 1
    ? t('NumberOfChapters', { chapters: numberOfChapters, ns: 'learningHub' })
    : t('SingleChapter', { ns: 'learningHub' });
  const tests = numberOfTests > 1
    ? t('NumberOfTests', { tests: numberOfTests, ns: 'learningHub' })
    : t('SingleTest', { ns: 'learningHub' });
  const certifications = numberOfCertifications > 1
    ? t('NumberOfCertifications', { certifications: numberOfCertifications, ns: 'learningHub' })
    : t('SingleCertification', { ns: 'learningHub' });

  return (
    <div className="module-content">
        <div className="progress-bar-container">
          {children}
        </div>
        <div className="module-title-section">
          <span className={`${comingSoon ? 'module-title-coming-soon' : 'module-title'}`}>
            {title}
          </span>
        </div>
        <p className="module-description">{description}</p>
        <div className="module-divider" />
        <div className="module-tags">
          <div className="chip">
            <span className="chip-text">{chapters}</span>
          </div>
          <div className="chip">
            <span className="chip-text">{tests}</span>
          </div>
          <div className="chip">
            <span className="chip-text">{certifications}</span>
          </div>
        </div>
      </div>
  )
}
